import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';

// App is our top level component
import { App, LogoutComponent } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { PagesModule } from './pages/pages.module';
import { ViewsService } from './pages/views/views.service';
import { UserLoginService } from './shared/_services/user-login.service';
import { NgaModule } from './theme/nga.module';

import { CognitoUtil } from './shared/_services/cognito.service';

// import { ModalModule } from 'ngx-bootstrap/modal';
import { NgIdleModule } from '@ng-idle/core';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { EnvironmentLoader } from 'environments/utils/environment-loader.util';
import { DialogModule } from 'primeng/dialog';
import { AuthGuard } from './shared/_guards';
import {
    AccessControlService,
    AlertService,
    AuthenticationService,
    CommonService,
    JWTInterceptor,
    NotifyService,
    SocketService,
    UserService,
} from './shared/_services';
import { ApiCachingService } from './shared/_services/api-caching.service';
import { BaThemeConfig, BaThemeConfigProvider } from './theme';
import {
    BaImageLoaderService,
    BaMenuService,
    BaThemePreloader,
    BaThemeSpinner,
} from './theme/services';

// Application wide providers
const APP_PROVIDERS = [AppState, GlobalState];

export type StoreType = {
    state: InternalStateType;
    restoreInputValues: () => void;
    disposeOldHosts: () => void;
};

export function initApp(): () => Promise<void> {
    return () => EnvironmentLoader.loadEnvironment();
}

export function cognitoUtilFactory(): CognitoUtil {
    return new CognitoUtil({
        region: EnvironmentLoader.environment.region,
        identityPoolId: EnvironmentLoader.environment.identityPoolId,
        userPoolId: EnvironmentLoader.environment.userPoolId,
        clientId: EnvironmentLoader.environment.clientId,
        endpoint: EnvironmentLoader.environment.cognito_idp_endpoint,
    });
}
/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [App],
    declarations: [App, LogoutComponent],
    imports: [
        // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        SimpleNotificationsModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        // NgaModule.forRoot(),
        NgaModule,
        NgbModule,
        PagesModule,
        routing,
        DialogModule,
        NgIdleModule.forRoot(),
        // ModalModule,
    ],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: () => () =>
                EnvironmentLoader.loadEnvironment().then(() => {
                    console.log('✅ Env ready');
                }),
            multi: true,
        },
        {
            provide: CognitoUtil,
            useFactory: cognitoUtilFactory,
        },
        // expose our Services and Providers into Angular's dependency injection
        APP_PROVIDERS,
        //customHttpProvider,
        AuthGuard,
        AlertService,
        ApiCachingService,
        AuthenticationService,
        UserService,
        CommonService,
        UserLoginService,
        ViewsService,
        NotifyService,
        BaImageLoaderService,
        BaMenuService,
        BaThemePreloader,
        BaThemeSpinner,
        BaThemeConfig,
        BaThemeConfigProvider,
        AccessControlService,
        SocketService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JWTInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {
    constructor(public appState: AppState) {}
}
console.log('17.3.1');
